import React, { Component } from "react";
import { AxiosError } from "axios";
import { postRequest } from "../../utils/httpRequest";

interface Props {
  // "bar": one line under the blog search. "box": a card after a post.
  variant: "bar" | "box";
}

interface State {
  email: string;
  username: string;
  saving: boolean;
  done: boolean;
  error: string;
}

// "New posts by email": its own list, separate from Weekend Reads, so joining
// or leaving one never touches the other. Email only; the hidden username
// field is the honeypot, so there is no captcha box to click.
class BlogSubscribe extends Component<Props, State> {
  unmounted = false;

  state: State = { email: "", username: "", saving: false, done: false, error: "" };

  componentWillUnmount() {
    this.unmounted = true;
  }

  onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const { email, username } = this.state;

    this.setState({ saving: true, error: "" });
    postRequest("/api/blog-subscriptions.json", { email, username })
      .then(() => {
        if (this.unmounted) return;
        this.setState({ saving: false, done: true });
      })
      .catch((error: AxiosError<{ errors?: { detail?: string }[] }>) => {
        if (this.unmounted) return;
        const detail = error.response?.data?.errors?.[0]?.detail;
        this.setState({
          saving: false,
          error: detail || "That didn't go through. Please try again.",
        });
      });
  };

  render() {
    const { variant } = this.props;
    const { email, username, saving, done, error } = this.state;
    const id = `blog-subscribe-${variant}`;

    if (done) {
      return (
        <div className={`blog-subscribe blog-subscribe--${variant} is-done`} role="status">
          <strong>You're on the list.</strong> The next post will land in your inbox.
        </div>
      );
    }

    return (
      <div className={`blog-subscribe blog-subscribe--${variant}`}>
        <div className="blog-subscribe__text">
          {variant === "box" ? (
            <>
              <strong>Get the next post by email.</strong>
              <span>New post most weeks. Just the post, nothing else.</span>
            </>
          ) : (
            <strong>
              New post most weeks. <em>Get them by email:</em>
            </strong>
          )}
        </div>
        <form className="blog-subscribe__form" onSubmit={this.onSubmit} aria-label="New posts by email">
          <label htmlFor={id} className="sr-only">
            Email address
          </label>
          <input
            id={id}
            type="email"
            required
            placeholder="you@work.com"
            autoComplete="email"
            value={email}
            onChange={(event) => this.setState({ email: event.target.value })}
          />
          <div className="blog-subscribe__honeypot" aria-hidden="true">
            <input
              type="text"
              name="username"
              tabIndex={-1}
              autoComplete="off"
              value={username}
              onChange={(event) => this.setState({ username: event.target.value })}
            />
          </div>
          <button type="submit" disabled={saving}>
            {saving ? "Signing up…" : "Sign up"}
          </button>
        </form>
        {error && (
          <p className="blog-subscribe__error" role="alert">
            {error}
          </p>
        )}
      </div>
    );
  }
}

export default BlogSubscribe;
